/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sklik_TitleInputs */

const cs_sklik_title = /** @type {(inputs: Sklik_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sklik (reklama Seznam)`)
};

const en_sklik_title = /** @type {(inputs: Sklik_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sklik (Seznam ads)`)
};

/**
* | output |
* | --- |
* | "Sklik (Seznam ads)" |
*
* @param {Sklik_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sklik_title = /** @type {((inputs?: Sklik_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sklik_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sklik_title(inputs)
	return cs_sklik_title(inputs)
});